<template>
  <div
    class="flex flex-wrap justify-between p-4"
    v-if="directoryLayoutsAvailable"
  >
    <div class="flex flex-col text-left">
      <span class="text-gray-900 font-inter text-base font-medium leading-6"
        >Booking System Layouts</span
      >
      <span class="text-gray-500 font-inter text-sm font-normal leading-8"
        >Manage your booking system templates</span
      >
    </div>
    <div class="flex flex-col">
      <div class="flex flex-wrap gap-6">
        <BaseButton
          type="button"
          class="bg-primary-purple text-white px-4 py-2 rounded-md font-inter text-base font-medium leading-6"
          @click="$emit('createNew')"
        >
          Create New Layout
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BaseButton from "@/components/shared/BaseButton.vue";

export default defineComponent({
  name: "DirectoryHeader",
  components: {
    BaseButton,
  },
  props: {
    directoryLayoutsAvailable: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["createNew"],
});
</script>
